enum EnergyClass {
  A3Plus = 'a3Plus',
  A2Plus = 'a2Plus',
  APlus = 'aPlus',
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g'
}

export default EnergyClass;
